import React from 'react';
import { render } from 'react-dom';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import Provider from 'react-redux/es/components/Provider';
import { connectRouter, routerMiddleware, ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import thunk from 'redux-thunk';
import AppContainer from './containers/App/AppContainer';
import * as reducers from './redux';
import { attachApiInterceptor } from './api/interceptor';
// import { unregister as unregisterServiceWorker } from './utils/registerServiceWorker';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

const history = createBrowserHistory();

const historyListener = (location) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
    ReactPixel.pageView();
};

history.listen(historyListener);

const appReducer = combineReducers({
    router: connectRouter(history),
    ...reducers
});
const store = createStore(
    appReducer,
    compose(
        applyMiddleware(
            routerMiddleware(history),
            thunk
        )
    )
);

attachApiInterceptor(store);

render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <AppContainer />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);

// unregisterServiceWorker();

// TODO:
// do formControl wrapper component, see envolve project

// update the campaigns & factios Tab compoennt to be like the campaign tabs
// also use push instead of replace with <Link /> instead of disptach

// replace moment with date-fns
// https://date-fns.org/v2.0.0-alpha.27/docs/Time-Zones
// https://www.npmjs.com/package/date-fns-tz

// update post input to have real smilies
// import PostMessageText from 'components/PostMessage/PostMessageText';
// make 1:1 with opaque form control
// add resize event listener to form.control resize PostMessageText container when resizing form
// add vertical reisize icon on the bottom right
// <div>
//     <div>
//         <PostMessageText message={this.state.message} isFormatted={true} />
//     </div>
//
//     <Form.Control
//         ref={this.REF_INPUT}
//         as='textarea'
//         value={this.state.message}
//         placeholder={'Propositions, idées d\'amélioration, aide recherchée ou à proposer, évènements.... partagez ici !'}
//         onChange={this.onChangeMessage} />
// </div>
